export const isEcommerceTransactionType = (transactionType) =>
    typeof transactionType === "string" &&
    transactionType.length === 20 &&
    transactionType.charAt(11) === "1";
